import React, { Component } from 'react';
import { Modal, Button } from 'antd';
import HightCharts from 'react-highcharts';

export default class extends Component {
  getConfig = () => ({
    chart: {
      type: 'column',
    },
    title: {
      text: `อัตราการรั่วซึม ที่ระดับ ${this.props.record.level}`,
    },
    xAxis: {
      type: 'category',
    },
    yAxis: {
      title: {
        text: 'mH2O',
      },
    },
    legend: {
      enabled: false,
    },
    series: [
      {
        colorByPoint: true,
        data: [
          {
            name: 'P(a)',
            y: this.props.record.head_start,
          },
          {
            name: 'P(b)',
            y: this.props.record.head_end,
          },
        ],
      },
    ],
  });

  render() {
    const { closeModal, record, Vc } = this.props;

    return (
      <Modal
        title={`อัตราการรั่วซึมที่ระดับ ${record.level}`}
        onCancel={closeModal}
        visible
        footer={<Button onClick={closeModal}>Close</Button>}
      >
        <HightCharts config={this.getConfig()} />
        <table className="table">
          <thead>
            <tr>
              <th className="text-center">#</th>
              <th className="text-center">A</th>
              <th className="text-center">B</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th>Pressure (KPA)</th>
              <td className="text-right">{record.pressure_start}</td>
              <td className="text-right">{record.pressure_end}</td>
            </tr>
            <tr>
              <th>mH2O(m.)</th>
              <td className="text-right">{record.head_start}</td>
              <td className="text-right">{record.head_end}</td>
            </tr>
            <tr>
              <th>q</th>
              <td colSpan={2} className="text-center">
                {record.q}
              </td>
            </tr>
            <tr>
              <th>{`V(${record.level})`}</th>
              <td colSpan={2} className="text-center">
                {record.v}
              </td>
            </tr>
            <tr>
              <th>Vc</th>
              <td colSpan={2} className="text-center">
                {Vc}
              </td>
            </tr>
            <tr>
              <th>Piping</th>
              <td colSpan={2} className="text-center">
                {record.piping}
              </td>
            </tr>
            <tr>
              <th>FS</th>
              <td colSpan={2} className="text-center">
                {record.fs}
              </td>
            </tr>
          </tbody>
        </table>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/components/SeepageSection/SeepageModal.js